(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var openModal = null;
    var lastTrigger = null;

    function closeModal() {
      if (!openModal) return;
      var body = openModal.querySelector('[data-hiw-modal-body]');
      var video = body && body.querySelector('video');
      if (video) video.pause();
      if (body) body.innerHTML = '';
      openModal.hidden = true;
      openModal = null;
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-hiw-close]')) {
        closeModal();
        return;
      }

      var trigger = event.target.closest('[data-hiw-play]');
      if (!trigger) return;

      var root = trigger.closest('.hiw');
      var media = trigger.closest('[data-hiw-media]');
      if (!root || !media) return;

      var modal = root.querySelector('[data-hiw-modal]') || root.__hiwModal;
      var template = media.querySelector('template');
      if (!modal || !template) return;

      /* verplaats de pop-up naar <body>, zodat hij nooit door de sectie wordt afgesneden */
      if (modal.parentNode !== document.body) {
        root.__hiwModal = modal;
        document.body.appendChild(modal);
      }

      var body = modal.querySelector('[data-hiw-modal-body]');
      body.innerHTML = '';
      body.appendChild(template.content.cloneNode(true));

      lastTrigger = trigger;
      modal.hidden = false;
      openModal = modal;

      var video = body.querySelector('video');
      if (video) {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
      var closeBtn = modal.querySelector('.hiw__modal-close');
      if (closeBtn) closeBtn.focus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
